<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-task :taskPageData='taskPage'></app-task>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import EventBus from '../event-bus';
    import FrontFooter from '@/components/partials/FrontFooter';
    import ListTasksComponent from "@/components/task/ListTasksComponent";
    import {addTask} from '../../config';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: "task",
        mixins: [SessioMixin],
        data () {
            return{
                taskPage: {
                    pageTitle: this.LabelName('task') + ' List',//'Tasks List',
                    perPage: 25,
                    cus_id: 0,
                    is_part: 0,
                },
                loginID: 0,
                permissions: [],
                cantAccessPage: true,
            }
        },
        components: {
            'app-task': ListTasksComponent,
            'app-footer': FrontFooter,
        },
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                self.isLoggedIn = true;
            }
        },
        mounted: function () {
            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Tasks.xlsx');
            $(".removeActive").removeClass('active');
            $("#menutasks").addClass('active');
            // console.log(this.message);
            this.showLoader();
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
//            this.loadTask();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
            // updateTask: function (id, key) {
            //     var self = this;
            //     console.log(id);
            //     // self.$router.push({path : '/task/update/' + id});
            // }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/task/ShowTask.vue